import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="url-multi-param"
export default class extends Controller {
  static targets = [ 'field' ]

  change() {
    let url = new URL(window.location.href)

    this.fieldTargets.forEach((field) => {
      // An unchecked checkbox still has a value, so treat it as empty.
      const value = field.type == 'checkbox' && !field.checked ? '' : field.value

      if (value == '' || value == null) {
        url.searchParams.delete(field.id)
      } else {
        url.searchParams.set(field.id, value)
        url.searchParams.delete('page') // Don't send page number to backend so that we start on page 1.
      }
    })

    window.location = url
  }
}
